import { render } from "./event-post.vue?vue&type=template&id=3bbd52fe"
import script from "./event-post.vue?vue&type=script&lang=js"
export * from "./event-post.vue?vue&type=script&lang=js"

import exportComponent from "/Users/aun/Development/thailand-fest/thai-festival-admin-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__